import { render, staticRenderFns } from "./StatisticPopup.vue?vue&type=template&id=7fca6372&scoped=true"
import script from "./StatisticPopup.vue?vue&type=script&lang=js"
export * from "./StatisticPopup.vue?vue&type=script&lang=js"
import style0 from "./StatisticPopup.vue?vue&type=style&index=0&id=7fca6372&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca6372",
  null
  
)

export default component.exports